let environment = 'live';

const getEnvironment = () => {
  return environment;
}

const setEnvironment = (env) => {
  environment = env;
}

module.exports = { getEnvironment, setEnvironment };